import type { NavPanel as NavPanelData } from '@assessments/shared'

interface Props {
  panel: NavPanelData
}

export function NavPanel({ panel }: Props) {
  return (
    <div className="w-[650px] overflow-hidden rounded-md bg-surface shadow-panel">
      <div className="p-6">
        <p className="whitespace-pre-line text-sm leading-relaxed text-body">{panel.body}</p>
        <a
          href={panel.cta_url}
          className="mt-4 inline-flex items-center rounded bg-heading px-4 py-2 text-sm font-medium text-inverse no-underline transition-opacity hover:opacity-90"
        >
          {panel.cta_label}
        </a>
      </div>
    </div>
  )
}
